import * as constants from './LiveModeCourse.constants';
import * as services from './LiveModeCourse.service';

const state = {
  Course: [],
  isRequest: false,
  Token: {},
};

const mutations = {
  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },

  [constants.GET_LIVE_TOKEN](state, token) {
    state.Token = token;
  },

  [constants.GET_LIVE_COURSE_SUCCESS](state, data) {
    if (data) {
      state.Course = data;
    } else {
      state.Course = [];
    }
  },
};

const actions = {
  async getLiveCourse({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getLiveCourse(payload);
    commit(constants.GET_LIVE_COURSE_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async getLiveToken({ commit }, payload) {
    const res = await services.getLiveToken(payload);
    commit(constants.GET_LIVE_TOKEN, res.data.data);
  },
};

const getters = {
  Course: (state) => state.Course,
  isRequest: (state) => state.isRequest,
  Token: (state) => state.Token,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
